import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Urbaniafordestinationinpune() {



    const cardData =
    {
        keyword: 'Urbania for Outstation in Pune',
        heading: 'Urbania on rent in pune: Urbania for Outstation in Pune',
        headingDescription: 'Urbania On Rent in Pune offers reliable and comfortable Urbania for Outstation in Pune services for corporate groups, families, tourists, and event travelers planning trips beyond the city. Our well-maintained Force Urbania fleet provides spacious seating, air-conditioned comfort, and smooth performance, making it ideal for long-distance travel, weekend getaways, airport transfers, corporate tours, weddings, and sightseeing from Pune to nearby cities and towns. With experienced chauffeurs, flexible one-way and round-trip rental options, and convenient doorstep pickup from major areas including Hinjewadi, Baner, Wakad, Kharadi, Hadapsar, Kothrud, Pimpri Chinchwad, and Pune Airport, we ensure a safe, punctual, and stress-free outstation journey. Backed by 24/7 booking support, competitive pricing, and trusted service, Urbania On Rent in Pune stands out as the preferred choice for outstation Urbania hire from Pune.',

        top: 'Top Places to Visit in Pune with Urbania on rent in pune',


        "topPlaces": [
            {
                "title": "Shaniwar Wada",
                "description": "Shaniwar Wada, built in 1732 by the Peshwas, is Pune’s most iconic historical landmark and a symbol of Maratha power. Once the administrative seat of Bajirao I, the fort complex featured grand halls, fountains, and courtyards. Although a major fire destroyed much of the structure, the massive stone walls, gates like the Delhi Darwaza, and remaining ruins still reflect its former grandeur. The evening light-and-sound show vividly narrates Maratha history, making it a must-visit heritage attraction."
            },
            {
                "title": "Aga Khan Palace",
                "description": "Aga Khan Palace is a significant monument linked to India’s freedom struggle. Built in 1892, it served as a prison for Mahatma Gandhi, Kasturba Gandhi, and Mahadev Desai during the Quit India Movement. Today, it houses a museum displaying photographs, letters, and personal belongings of Gandhi. Surrounded by lush gardens and Italian-style arches, the palace offers a peaceful yet historically powerful experience."
            },
            {
                "title": "Sinhagad Fort",
                "description": "Sinhagad Fort stands atop a rugged hill in the Sahyadri range and is renowned for the heroic sacrifice of Tanaji Malusare in 1670. The fort offers breathtaking panoramic views of Pune and surrounding valleys. Visitors can trek or drive to explore ancient ramparts, memorials, and gates. Local food stalls serving traditional pithla-bhakri add to the authentic experience, making it a favorite spot for history lovers and adventure seekers."
            },
            {
                "title": "Dagdusheth Halwai Ganpati Temple",
                "description": "The Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most revered Ganesh temple. The beautifully adorned idol, decorated with gold ornaments, attracts thousands of devotees daily. During Ganesh Chaturthi, the temple becomes the heart of grand celebrations with processions and cultural events. The temple trust is also known for its social and charitable initiatives, making it both a spiritual and cultural landmark."
            },
            {
                "title": "Pataleshwar Cave Temple",
                "description": "Pataleshwar Cave Temple is an 8th-century rock-cut shrine dedicated to Lord Shiva, carved from a single basalt rock. Despite being located in a busy area, the temple offers a calm and meditative atmosphere. The monolithic pillars, circular Nandi mandap, and ancient carvings showcase early Indian craftsmanship. It is one of Pune’s lesser-known yet spiritually rich heritage sites."
            },
            {
                "title": "Raja Dinkar Kelkar Museum",
                "description": "Raja Dinkar Kelkar Museum houses over 20,000 artifacts collected by Dr. Dinkar Kelkar to preserve Indian art and culture. Exhibits include musical instruments, sculptures, lamps, utensils, and traditional household items. The recreated Mastani Mahal is a major highlight. The museum offers a deep insight into India’s cultural diversity and traditional craftsmanship."
            },
            {
                "title": "Parvati Hill and Temple",
                "description": "Parvati Hill is one of Pune’s oldest heritage sites, offering panoramic city views after climbing 103 stone steps. The hilltop temple complex dates back to the Peshwa era and is dedicated to Lord Shiva and Goddess Parvati. Smaller temples and a museum enrich the visit. Sunrise and sunset views from the hill are especially popular among locals and tourists."
            },
            {
                "title": "Osho Ashram",
                "description": "Located in Koregaon Park, the Osho International Meditation Resort is a world-famous center for meditation and mindfulness. Spread across landscaped gardens, it offers meditation programs, wellness therapies, and spiritual retreats. Visitors from across the globe come here seeking inner peace, relaxation, and personal transformation, making it an international spiritual destination."
            },
            {
                "title": "Pu La Deshpande Garden",
                "description": "Pu La Deshpande Garden, inspired by Japan’s Korakuen Garden, is Pune’s largest landscaped garden. It features flowing streams, arched bridges, manicured lawns, and seasonal flowers. Ideal for morning walks, family outings, and photography, the garden blends Japanese aesthetics with Indian natural beauty, offering a serene green escape."
            },
            {
                "title": "Khadakwasla Dam",
                "description": "Khadakwasla Dam, built on the Mutha River, is a popular weekend getaway near Pune. The vast reservoir, cool breeze, and surrounding hills create a refreshing atmosphere, especially during monsoon and evenings. Street vendors selling corn and tea add local charm. It also serves as a gateway to Sinhagad Fort, making it a scenic leisure destination."
            }
        ],



"services": [
    {
      "name": "Urbania for Outstation in Pune",
      "description": "Urbania for Outstation in Pune offers comfortable and reliable Urbania vehicles for long-distance travel beyond the city limits. Perfect for family trips, corporate travel, and group outings, these well-maintained vehicles ensure safety, spacious seating, and courteous chauffeur service for a stress-free journey to destinations across Maharashtra."
    },
    {
      "name": "Outstation Urbania Hire Pune",
      "description": "Outstation Urbania Hire Pune provides premium and dependable Urbania vehicles for intercity travel. Ideal for group travel, weekend getaways, or business trips, the service emphasizes comfort, timely pickups, highway-experienced drivers, and well-equipped interiors to ensure a smooth and enjoyable journey."
    },
    {
      "name": "Urbania Outstation Bus Rental Pune",
      "description": "Urbania Outstation Bus Rental Pune delivers spacious, fully equipped buses for group travel to cities and tourist destinations. With experienced chauffeurs, clean interiors, and ample luggage space, this service makes long-distance journeys convenient, safe, and cost-effective for schools, corporates, and social groups."
    },
    {
      "name": "Urbania for Long Distance Travel Pune",
      "description": "Urbania for Long Distance Travel Pune provides reliable and comfortable vehicles for extended trips across cities. Designed for families, friends, and corporate teams, these Urbanias ensure smooth highway travel, safety features, and professional drivers who are well-versed in intercity routes."
    },
    {
      "name": "Pune to Mumbai Urbania Hire",
      "description": "Pune to Mumbai Urbania Hire offers dedicated transportation for seamless travel between Pune and Mumbai. Equipped with comfortable seating, climate control, and expert chauffeurs, this service caters to business travelers, tourists, and group outings, ensuring punctual and hassle-free journeys."
    },
    {
      "name": "Pune to Shirdi Urbania on Rent",
      "description": "Pune to Shirdi Urbania on Rent provides convenient and comfortable vehicles for religious and leisure trips. With spacious interiors, safety features, and experienced chauffeurs, travelers can enjoy a stress-free journey while reaching their destination on time and in comfort."
    },
    {
      "name": "Pune to Nashik Urbania Hire",
      "description": "Pune to Nashik Urbania Hire ensures safe and comfortable travel for small groups and families heading to Nashik. With well-maintained vehicles, professional drivers, and flexible scheduling, this service combines convenience, affordability, and reliability for long-distance journeys."
    },
    {
      "name": "Pune to Mahabaleshwar Urbania Rental",
      "description": "Pune to Mahabaleshwar Urbania Rental provides reliable transportation for hill station trips and weekend getaways. Vehicles are clean, spacious, and driven by experienced chauffeurs who are familiar with highway and hilly terrains, ensuring safe and pleasant travel experiences."
    },
    {
      "name": "Outstation AC Urbania Pune",
      "description": "Outstation AC Urbania Pune offers fully air-conditioned vehicles for comfortable long-distance travel. Perfect for families, corporate teams, and tourists, the service ensures smooth rides, professional chauffeurs, timely pickups, and a relaxing journey across cities."
    },
    {
      "name": "Corporate Outstation Urbania Pune",
      "description": "Corporate Outstation Urbania Pune delivers reliable and professional intercity transportation for office trips, conferences, and corporate events. Equipped with comfortable seating, experienced drivers, and punctual service, it caters to executives and teams seeking efficient and stress-free travel solutions."
    },
    {
      "name": "Chauffeur Driven Outstation Urbania Pune",
      "description": "Chauffeur Driven Outstation Urbania Pune provides stress-free long-distance travel with trained and verified drivers. Vehicles are well-maintained, comfortable, and equipped for extended journeys, making it ideal for families, corporate teams, and group travelers looking for convenience and safety."
    },
    {
      "name": "Affordable Outstation Urbania Hire Pune",
      "description": "Affordable Outstation Urbania Hire Pune delivers cost-effective solutions for intercity travel without compromising on comfort or reliability. With clean vehicles, professional chauffeurs, and transparent pricing, it is perfect for budget-conscious travelers planning long-distance trips."
    },
    {
      "name": "Urbania Group Outstation Travel Pune",
      "description": "Urbania Group Outstation Travel Pune offers organized and comfortable long-distance transport for group tours, corporate outings, and family trips. Spacious seating, ample luggage space, and experienced chauffeurs ensure a smooth and enjoyable journey for everyone on board."
    },
    {
      "name": "Best Outstation Urbania Rental Pune",
      "description": "Best Outstation Urbania Rental Pune provides top-rated intercity transportation services with well-maintained vehicles, experienced drivers, and exceptional customer support. Ideal for families, corporate travelers, and group outings seeking reliability, comfort, and punctuality for long-distance travel."
    },
    {
      "name": "Trusted Outstation Urbania Service Pune",
      "description": "Trusted Outstation Urbania Service Pune ensures safe, reliable, and comfortable travel for long-distance trips. With professional chauffeurs, well-maintained vehicles, and a focus on customer satisfaction, travelers can enjoy peace of mind and a hassle-free journey across Maharashtra."
    }
  ],
  "tableData": [
    ["Urbania for Outstation in Pune", "Outstation Urbania Hire Pune"],
    ["Urbania Outstation Bus Rental Pune", "Urbania for Long Distance Travel Pune"],
    ["Pune to Mumbai Urbania Hire", "Pune to Shirdi Urbania on Rent"],
    ["Pune to Nashik Urbania Hire", "Pune to Mahabaleshwar Urbania Rental"],
    ["Outstation AC Urbania Pune", "Corporate Outstation Urbania Pune"],
    ["Chauffeur Driven Outstation Urbania Pune", "Affordable Outstation Urbania Hire Pune"],
    ["Urbania Group Outstation Travel Pune", "Best Outstation Urbania Rental Pune"],
    ["Trusted Outstation Urbania Service Pune", ""]
  ],





"whychoose": [
    {
        "WhyChooseheading": "Reliable Urbania for Outstation in Pune",
        "WhyChoosedescription": "Urbania for Outstation in Pune is the perfect choice for long-distance travel, providing spacious and comfortable seating for families, groups, and corporate trips."
    },
    {
        "WhyChooseheading": "Spacious and Comfortable Force Urbania Vehicles",
        "WhyChoosedescription": "Urbania for Outstation in Pune offers well-maintained Force Urbania vehicles with ample legroom and luggage space, ensuring a smooth and comfortable journey."
    },
    {
        "WhyChooseheading": "Experienced and Professional Drivers",
        "WhyChoosedescription": "Urbania for Outstation in Pune comes with skilled drivers familiar with highways and local routes, ensuring safety, punctuality, and a hassle-free travel experience."
    },
    {
        "WhyChooseheading": "Transparent and Affordable Pricing",
        "WhyChoosedescription": "Choose Urbania for Outstation in Pune for competitive rates with no hidden charges, making long-distance group travel budget-friendly and reliable."
    },
    {
        "WhyChooseheading": "24/7 Booking and Customer Support",
        "WhyChoosedescription": "Urbania for Outstation in Pune provides round-the-clock assistance for bookings, travel inquiries, and last-minute trip requirements."
    },
    {
        "WhyChooseheading": "Flexible Rental Packages",
        "WhyChoosedescription": "Urbania for Outstation in Pune is available for hourly, full-day, or multi-day bookings, corporate travel, wedding transportation, and customized outstation packages."
    },
    {
        "WhyChooseheading": "Clean, Sanitized, and Well-Maintained Vehicles",
        "WhyChoosedescription": "All Urbania vehicles for outstation trips are regularly cleaned, sanitized, and serviced to ensure a safe and comfortable journey."
    },
    {
        "WhyChooseheading": "Punctual and Reliable Service",
        "WhyChoosedescription": "Urbania for Outstation in Pune guarantees timely pickups and dependable service, ensuring stress-free and smooth long-distance travel."
    }
]
}

const faqData = [
    {
        question: 'Is Urbania for Outstation in Pune available for local travel as well?',
        answer: 'Yes, Urbania for Outstation in Pune can be booked for both local and outstation travel, offering spacious and comfortable rides.',
    },
    {
        question: 'How can I book Urbania for Outstation in Pune?',
        answer: 'You can book Urbania for Outstation in Pune via phone, WhatsApp, or online for quick and hassle-free reservations.',
    },
    {
        question: 'Why choose Urbania for Outstation in Pune for group travel?',
        answer: 'Urbania for Outstation in Pune offers ample seating, luggage space, and a smooth ride, making it ideal for family, corporate, and group travel.',
    },
    {
        question: 'Is Urbania for Outstation in Pune suitable for corporate and event travel?',
        answer: 'Yes, it is perfect for corporate trips, airport transfers, weddings, events, and long-distance journeys.',
    },
    {
        question: 'Are drivers experienced with Urbania for Outstation in Pune?',
        answer: 'Yes, all drivers are professionally trained, licensed, and experienced in handling Force Urbania vehicles for safe and comfortable travel.',
    },
    {
        question: 'Can I customize pickup and drop-off locations with Urbania for Outstation in Pune?',
        answer: 'Absolutely. Urbania for Outstation in Pune allows flexible pickup and drop-off across Pune and nearby areas.',
    },
    {
        question: 'Is Urbania for Outstation in Pune available 24x7?',
        answer: 'Yes, Urbania for Outstation in Pune operates 24x7 to meet travel needs at any time.',
    },
    {
        question: 'Are hygiene and safety standards maintained for Urbania for Outstation in Pune?',
        answer: 'Yes, all vehicles are regularly cleaned, sanitized, and maintained with strict safety protocols for every trip.',
    },
    {
        question: 'What payment options are available for Urbania for Outstation in Pune?',
        answer: 'Urbania for Outstation in Pune accepts UPI, digital wallets, credit/debit cards, bank transfers, and corporate billing options.',
    },
    {
        question: 'Is customer support available during the journey?',
        answer: 'Yes, dedicated customer support is available throughout the journey to ensure a smooth and stress-free experience.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Vinay Deshpande',
        feedback: 'We booked Urbania for Outstation in Pune for a long-distance family trip. The vehicle was spacious, comfortable, and reliable. Excellent experience!',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Anjali Patil',
        feedback: 'Urbania for Outstation in Pune provided seamless service for our corporate outstation travel. The driver was professional and punctual. Highly recommended!',
        rating: 5,
    },
];

























































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Urbania On Rent Pune", link: "urbania-on-rent-pune" },
        { place: "/images/keyword/2.jpg", text: "Urbania on Rent in Pimpri Chinchwad", link: "urbania-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/3.jpg", text: "Urbania Hire for Corporate Events in Pune", link: "urbania-hire-for-corporate-events-in-pune" },
        { place: "/images/keyword/4.jpg", text: "17 Seater Urbania on Rent in Pune", link: "17-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/5.jpg", text: "14 Seater Urbania on Rent in Pune", link: "14-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/6.jpg", text: "Urbania on Rent in Kharadi", link: "urbania-on-rent-in-kharadi" },
        { place: "/images/keyword/7.jpg", text: "Urbania on Rent in Hadapsar", link: "urbania-on-rent-in-hadapsar" },
        { place: "/images/keyword/8.jpg", text: "Urbania on Rent in Kothrud", link: "urbania-on-rent-in-kothrud" },
        { place: "/images/keyword/9.jpg", text: "Urbania On Rent in Bibwewadi", link: "urbania-on-rent-in-bibwewadi" },
        { place: "/images/keyword/10.jpg", text: "Urbania on Rent in Koregaon Park", link: "urbania-on-rent-in-koregaon-park" },
        { place: "/images/keyword/11.jpg", text: "Urbania On Rent in Kalyani Nagar", link: "urbania-on-rent-in-kalyani-nagar" },
        { place: "/images/keyword/12.jpg", text: "Urbania On Rent in Mundhwa Pune", link: "urbania-on-rent-in-mundhwa-pune" },
        { place: "/images/keyword/13.jpg", text: "Urbania Bus On Rent in Baner", link: "urbania-bus-on-rent-in-baner" },
        { place: "/images/keyword/14.jpg", text: "Urbania AC Bus On Rent in Aundh", link: "urbania-ac-bus-on-rent-in-aundh" },
        { place: "/images/keyword/15.jpg", text: "Urbania Bus On Rent in Hinjewadi", link: "urbania-bus-on-rent-in-hinjewadi" },
        { place: "/images/keyword/16.jpg", text: "Urbania on Rent in Bhosari", link: "urbania-on-rent-in-bhosari" },
        { place: "/images/keyword/17.jpg", text: "Urbania on Rent in Pune Station", link: "urbania-on-rent-in-pune-station" },
        { place: "/images/keyword/18.jpg", text: "Urbania On Rent in Chakan", link: "urbania-on-rent-in-chakan" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Moshi", link: "urbania-on-rent-in-moshi" },
        { place: "/images/keyword/20.jpg", text: "Urbania On Rent in Charholi Budruk", link: "urbania-on-rent-in-charholi-budruk" },
        { place: "/images/keyword/21.jpg", text: "Urbania On Rent in Nigdi Pradhikaran", link: "urbania-on-rent-in-nigdi-pradhikaran" },
        { place: "/images/keyword/22.jpg", text: "Urbania On Rent in Lohegaon", link: "urbania-on-rent-in-lohegaon" },
        { place: "/images/keyword/23.jpg", text: "Urbania On Rent in Wagholi", link: "urbania-on-rent-in-wagholi" },
        { place: "/images/keyword/24.jpg", text: "Urbania Rental Service in Pune", link: "urbania-rental-service-in-pune" },
        { place: "/images/keyword/25.jpg", text: "Best Urbania on Rent in Pune", link: "best-urbania-on-rent-in-pune" }
    ];













const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Urbania for Outstation in Pune",
  "image": "https://urbaniaonrentpune.in/assets/images/urbania-for-outstation-pune.jpg",
  "description": "Urbania for Outstation in Pune offers reliable Force Urbania bus rental services for long-distance travel including Pune to Mumbai, Shirdi, Nashik, and Mahabaleshwar. AC and non-AC Urbania buses with professional chauffeur-driven service are available for corporate trips, group travel, and family outings at affordable rates.",
  "brand": {
    "@type": "Brand",
    "name": "Urbania on Rent in Pune"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "1380",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "6000",
    "availability": "https://schema.org/InStock",
    "url": "https://urbaniaonrentpune.in/urbania-for-outstation-pune"
  }
};






    return (
        <div>
<Helmet>
  <title>
    Call:+91 9209423113 | Urbania for Outstation in Pune | Long Distance & Group Travel Urbania Hire 
  </title>

  <meta
    name="description"
    content="Book Urbania for Outstation in Pune for long-distance travel including Pune to Mumbai, Shirdi, Nashik, and Mahabaleshwar. AC and non-AC Urbania buses with chauffeur-driven service for corporate, group, and family travel at affordable rates."
  />

  <meta
    name="keywords"
    content="Urbania for Outstation in Pune, Outstation Urbania Hire Pune, Urbania Outstation Bus Rental Pune, Urbania for Long Distance Travel Pune, Pune to Mumbai Urbania Hire, Pune to Shirdi Urbania on Rent, Pune to Nashik Urbania Hire, Pune to Mahabaleshwar Urbania Rental, Outstation AC Urbania Pune, Corporate Outstation Urbania Pune, Chauffeur Driven Outstation Urbania Pune, Affordable Outstation Urbania Hire Pune, Urbania Group Outstation Travel Pune, Best Outstation Urbania Rental Pune, Trusted Outstation Urbania Service Pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
            <div
                className="breadcumb-wrapper"
                
                data-overlay="black"
                data-opacity="3"
            >
                <div className="container">
                    <div className="breadcumb-content text-center">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/30.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>



                            <div className="shambhu-services">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="sh-service-card">

                                        <div className="sh-service-left">
                                            <div className="sh-service-icon">
                                                🚌
                                            </div>
                                        </div>

                                        <div className="sh-service-content">
                                            <h4 className="sh-service-title">{service.name}</h4>
                                            <p className="sh-service-desc">{service.description}</p>
                                        </div>

                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Urbania On rent in Pune </span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Urbania on rent in Pune </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919209423113" className="pc-call">+91 9209423113</a>
                                            <a href="tel:+917620411277 " className="pc-call">+91 7620411277 </a>
                                            <a href="tel:+919284718314" className="pc-call">+91 9284718314</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919209423113"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919209423113" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@urbaniaonrentpune.in" className="pc-email">
                                            booking@urbaniaonrentpune.in
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Urbania on rent in pune</strong><br />
                                            Saket Tata Power CHS, Swami Samarth Marg,
                                            Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                                            Maharashtra India - 400703
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Urbaniafordestinationinpune;